module.exports = __webpack_public_path__ + "fonts/352cf1d.eot";